import React from "react";
import { LetterButton } from "./LetterButton";
import { ButtonState } from "../Hangman";

interface LettersProps {
  handleLetterPressed: Function;
  buttonStateMap: Map<string, ButtonState>;
}

export const Letters = ({ handleLetterPressed, buttonStateMap }: LettersProps) => {
  const keysArr = Array.from(buttonStateMap.keys());

  return (
    <div className="border border-gray-300 rounded-lg shadow-sm text-center">
      <div className="p-4">
        {keysArr.map((letter) => (
          <LetterButton
            key={letter}
            handleLetterPressed={handleLetterPressed}
            letter={letter}
            color={buttonStateMap?.get(letter)?.color}
            isDisabled={buttonStateMap?.get(letter)?.isDisabled}
          />
        ))}
      </div>
    </div>
  );
};
